export default __webpack_public_path__ + "static/media/ab_headerlogo.cf0fbe4c.png";